import type { FooterContent } from "@/types/report";

interface Props {
  content: FooterContent;
}

export function FooterSection({ content }: Props) {
  return (
    <div className="report-footer">
      <div>Generated {content.generatedAt}</div>
      {content.pubUrl && (
        <div style={{ marginTop: 8 }}>
          <a
            href={content.pubUrl}
            target="_blank"
            rel="noreferrer noopener"
            style={{ color: "var(--report-accent, #c9a96e)" }}
          >
            View published report
          </a>
        </div>
      )}
    </div>
  );
}
